export const CLEANING_AREA_TYPES = {
  NONE: 'none',
  UNKNOWN: 'unknown',
  COMMON: 'common',
  FULL: 'full'
};

export const CLEANING_PERIODICITY_TYPES = {
  NONE: 'none',
  UNKNOWN: 'unknown',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly'
};
